import ModalComponent from '@components/common/Modal';
import { ThunkDispatch } from '@reduxjs/toolkit';
import {
  getDetailOfOrder,
  updateOpenCreateModal,
  updateOpenCreateOrderModal,
  updateReqReGetOrder
} from '@slice/orderManager.slice';
import { Button, Divider, message, Modal, Table } from 'antd';
import { RootState } from 'app/store';
import Helpers from 'helpers/Helpers';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { updatePageLoadingApi } from '@slice/select.slice';
import OrderManagerApi, { TTypeStatusAPI } from 'apis/api/OrderManager';
import { TTypeStatusMsg } from '@models/OrderManager';
import dayjs from 'dayjs';

type IConfirmOrders = {
  resetAllForm?: () => any;
  // clickSubmitForm?: () => any;
  callBackCloseModal?: () => any;
  // form?: FormInstance<any> | undefined;
  setConfirmLoading?: (value?: boolean) => any;
  typeOrder?: string;
  callBackConfirm?: () => any;
  setCustomerCode?: any;
};

export default function ConfirmOrderModal(props: IConfirmOrders) {
  const { t } = useTranslation();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  const openCodeCreateModal = useSelector((state: RootState) => state.orderManager.openCodeCreateModal);
  const createOrders = useSelector((state: RootState) => state.orderManager.createOrders);
  const [arrayBS, setArrayBS] = useState<any[]>([]);

  const itemTypeCoop = useSelector((state: RootState) => state.select.typeCoopData);
  useEffect(() => {
    if (uLogin?.ActionOrder?.permissionsCheckTrungBS) {
      try {
        const bodyReq =
          fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Sửa chữa' ||
          fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Bảo hành'
            ? createOrders['dataBody'].errors
            : //  createOrders['dataBody'].errors.filter(e => {
              //     return typeof e.details !== 'undefined' || e.newMaSanPham !== undefined;
              //   })
              createOrders['dataBody']?.items;
        const orderTypeId = createOrders['dataBody'].orderTypeId;
        // const typeApiReq = typeOrderAPI || null;
        const listBs = [];

        for (let i = 0; i < bodyReq.length; i++) {
          if (bodyReq[i].oldRegistrationPlate && bodyReq[i].newRegistrationPlate) {
            listBs.push(bodyReq[i].oldRegistrationPlate, bodyReq[i].newRegistrationPlate);
          } else if (bodyReq[i].oldRegistrationPlate) {
            listBs.push(bodyReq[i].oldRegistrationPlate);
          } else if (bodyReq[i].newRegistrationPlate) {
            listBs.push(bodyReq[i].newRegistrationPlate);
          } else if (bodyReq[i].bs) {
            listBs.push(bodyReq[i].bs);
          } else {
            listBs.push(bodyReq[i].registrationPlate);
          }
        }

        const listCheckBienSo = [{ listBs, orderType: orderTypeId }];
        if (bodyReq && uLogin?.ActionOrder?.createOrder) {
          setConfirmLoading(true);
          // props.isModalCreate && props.setConfirmLoading(true);
          OrderManagerApi.CheckTrungBS({ listCheckBienSo }).then(res => {
            // console.log('res', res);
            if (!res.data.error) {
              setArrayBS(res.data.data);
            } else {
              message.error(t('OrganizedSales.OrderManager.CreateOrder.Error'));
              // message.error(t('OrganizedSales.OrderManager.CreateOrder.Error') + ' ' + res.data.message, 10);
            }
            setConfirmLoading(false);
          });
        }
      } catch (error) {
        message.error(t('OrganizedSales.OrderManager.CreateOrder.Error'));
        setConfirmLoading(false);
      }
    } else {
      return;
    }
  }, [createOrders]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel1 = () => {
    setIsModalOpen(false);
  };

  const uLogin = useSelector((state: RootState) => state.user.account);
  const productCategoryPMP = useSelector((state: RootState) => state.createOrder.listProductMixDataPaging);
  const productCategoryPMS = useSelector((state: RootState) => state.createOrder.dataProductMixSearch);
  const [order, setOrder] = useState<any>(); // các đơn còn lại
  const [heigth, setHeigth] = useState(window.innerHeight);
  useEffect(() => {
    const handleResize = () => {
      setHeigth(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const convertOrder = (detail, text) => {
    if (text === 'tp') {
      const listProMix = [...productCategoryPMP, ...productCategoryPMS];
      // const detail = createOrders['rowSelected']?.DeviceList;
      const tempDetail = [...detail].map((item: any, index: number) => ({
        Key: item.maSanPham + item.cost + item.bs,
        child: {
          ...item
        }
      }));

      // bước tiếp theo là tiến hành gom các chi tiết có cùng bs cũ -> bs mới lại với nhau với child chứa các chi tiết bên trong đó
      // lưu ý là phải đúng với format bên form update
      const mergeList = new Map(tempDetail.map(({ Key, child }) => [Key, { Key, child: [] }]));
      for (const { Key, child } of tempDetail) mergeList.get(Key)?.child.push(...[child].flat());

      const tempList: any = [];
      for (let i = 0; i < [...mergeList.values()]?.length; i++) {
        const obj = {
          ...[...mergeList.values()][i]
        };

        if ([...mergeList.values()][i].child?.length != 0) {
          const childFirst = {
            ...[...mergeList.values()][i].child[0]
          };
          const findPM = listProMix.find(proMix => proMix.maSanPham == childFirst?.maSanPham);

          if (findPM?.input === 0) {
            // cần xử lý vụ id tại đây
            // phần để xử lý ids nếu cần giữ lại id gửi lên, đây bán phụ kiện mới có sl nên k cần xử lý ids list này
            // const listID: any = [...mergeList.values()][i]?.child.map(ch => ch.id || 0);
            // obj.child[0]['ids'] = [...listID, ...([...mergeList.values()][i]?.child[0]['ids'] || [])].filter(function (
            //   item,
            //   index,
            //   arr
            // ) {
            //   return arr.indexOf(item) === index;
            // });
            obj.child[0]['tienSP'] =
              (obj.child[0]['amount'] || 0) +
              (obj.child?.length - ((obj.child[0]['amount'] && 1) || 0)) *
                ((obj.child[0]?.cost === null || obj.child[0]?.cost !== undefined || obj.child[0]?.cost == 0) && // cho phép giá 0, giá mà undefined là để và có báo lỗi, còn giá mà null là ngt a xoá hết input cứ để đó là báo lỗi input rỗng
                obj.child[0]?.cost != findPM?.giaBanSi && // giá nhập khác giá gốc sp
                (obj.child[0]?.maSanPham == obj.child[0]?.preMaSanPham || !obj.child[0]?.preMaSanPham) // chọn lại sản phẩm khác!
                  ? obj.child[0]?.cost
                  : findPM?.giaBanSi);
            obj.child[0]['isRequireSP'] = findPM?.input || 0;
            obj.child[0]['amount'] =
              (obj.child[0]['amount'] || 0) + (obj.child?.length - ((obj.child[0]['amount'] && 1) || 0));
            obj.child[0]['spTP'] = obj.child[0]['type'] === 0 ? 1 : 0;
            obj.child[0]['cost'] =
              (obj.child[0]?.cost === null || obj.child[0]?.cost !== undefined || obj.child[0]?.cost == 0) && // cho phép giá 0, giá mà undefined là để và có báo lỗi, còn giá mà null là ngt a xoá hết input cứ để đó là báo lỗi input rỗng
              obj.child[0]?.cost != findPM?.giaBanSi && // giá nhập khác giá gốc sp
              (obj.child[0]?.maSanPham == obj.child[0]?.preMaSanPham || !obj.child[0]?.preMaSanPham) // chọn lại sản phẩm khác!
                ? obj.child[0]?.cost
                : findPM?.giaBanSi;
            obj.child[0]['preMaSanPham'] = obj.child[0]?.maSanPham;
            obj.child[0]['cameraCount'] = obj.child[0]?.isCamera ? obj.child[0]?.cameraCount : 0;
            obj.child[0]['servicePackName'] = obj.child[0]?.isCamera ? obj.child[0]?.servicePackName : 0;
            tempList.push({ ...obj.child[0] });
          } else {
            for (let j = 0; j < [...mergeList.values()][i].child.length; j++) {
              const dtl = [...mergeList.values()][i].child[j];
              tempList.push({
                ...[...mergeList.values()][i].child[j],
                // cost:
                //   !dtl.old && !uLogin.ActionOrder.editWillPay
                //     ? 0
                //     : (dtl?.cost === null || dtl?.cost !== undefined || dtl?.cost == 0) && // cho phép giá 0, giá mà undefined là để và có báo lỗi, còn giá mà null là ngt a xoá hết input cứ để đó là báo lỗi input rỗng
                //       dtl?.cost != findPM?.giaBanSi && // giá nhập khác giá gốc sp
                //       (dtl?.maSanPham == dtl?.preMaSanPham || !dtl?.preMaSanPham) // chọn lại sản phẩm khác!
                //     ? dtl?.cost
                //     : findPM?.giaBanSi,
                cameraCount: dtl.isCamera ? dtl.cameraCount : 0,
                servicePackName: dtl.isCamera ? dtl.servicePackName : 0,
                tienSP: dtl.type !== 0 ? +dtl.cost : '',
                spTP: dtl.type === 0 ? 1 : 0,
                preMaSanPham: dtl?.maSanPham,
                isRequireSP: findPM?.input || 0
              });
            }
          }
        }
      }

      return tempList || [];
    } else if (text === 'taodontp') {
      const listProMix = [...productCategoryPMP, ...productCategoryPMS];
      // const detail = createOrders['rowSelected']?.DeviceList;
      const tempDetail = [...detail].map((item: any, index: number) => ({
        Key: item.maSanPham + item.cost + item.bs,
        child: {
          ...item
        }
      }));

      // bước tiếp theo là tiến hành gom các chi tiết có cùng bs cũ -> bs mới lại với nhau với child chứa các chi tiết bên trong đó
      // lưu ý là phải đúng với format bên form update
      const mergeList = new Map(tempDetail.map(({ Key, child }) => [Key, { Key, child: [] }]));
      for (const { Key, child } of tempDetail) mergeList.get(Key)?.child.push(...[child].flat());

      const tempList: any = [];
      for (let i = 0; i < [...mergeList.values()]?.length; i++) {
        const obj = {
          ...[...mergeList.values()][i]
        };

        if ([...mergeList.values()][i].child?.length != 0) {
          const childFirst = {
            ...[...mergeList.values()][i].child[0]
          };
          const findPM = listProMix.find(proMix => proMix.maSanPham == childFirst?.maSanPham);

          if (findPM?.input === 0) {
            obj.child[0]['tienSP'] =
              (obj.child[0]['amount'] || 0) *
              ((obj.child[0]?.cost === null || obj.child[0]?.cost !== undefined || obj.child[0]?.cost == 0) && // cho phép giá 0, giá mà undefined là để và có báo lỗi, còn giá mà null là ngt a xoá hết input cứ để đó là báo lỗi input rỗng
              obj.child[0]?.cost != findPM?.giaBanSi && // giá nhập khác giá gốc sp
              (obj.child[0]?.maSanPham == obj.child[0]?.preMaSanPham || !obj.child[0]?.preMaSanPham) // chọn lại sản phẩm khác!
                ? obj.child[0]?.cost
                : findPM?.giaBanSi);
            obj.child[0]['isRequireSP'] = findPM?.input || 0;
            obj.child[0]['amount'] = obj.child[0]['amount'] || 0;
            obj.child[0]['spTP'] = !obj.child[0]['amount'] || obj.child[0]['amount'] === 0 ? 1 : 0;
            obj.child[0]['cost'] =
              (obj.child[0]?.cost === null || obj.child[0]?.cost !== undefined || obj.child[0]?.cost == 0) && // cho phép giá 0, giá mà undefined là để và có báo lỗi, còn giá mà null là ngt a xoá hết input cứ để đó là báo lỗi input rỗng
              obj.child[0]?.cost != findPM?.giaBanSi && // giá nhập khác giá gốc sp
              (obj.child[0]?.maSanPham == obj.child[0]?.preMaSanPham || !obj.child[0]?.preMaSanPham) // chọn lại sản phẩm khác!
                ? obj.child[0]?.cost
                : findPM?.giaBanSi;
            obj.child[0]['preMaSanPham'] = obj.child[0]?.maSanPham;
            tempList.push({ ...obj.child[0] });
          } else {
            for (let j = 0; j < [...mergeList.values()][i].child.length; j++) {
              const dtl = [...mergeList.values()][i].child[j];
              tempList.push({
                ...[...mergeList.values()][i].child[j],
                cameraCount: dtl.isCamera ? dtl.cameraCount : 0,
                servicePackName: dtl.isCamera ? dtl.servicePackName : 0,
                // cost:
                //   !dtl.old && !uLogin.ActionOrder.editWillPay
                //     ? 0
                //     : (dtl?.cost === null || dtl?.cost !== undefined || dtl?.cost == 0) && // cho phép giá 0, giá mà undefined là để và có báo lỗi, còn giá mà null là ngt a xoá hết input cứ để đó là báo lỗi input rỗng
                //       dtl?.cost != findPM?.giaBanSi && // giá nhập khác giá gốc sp
                //       (dtl?.maSanPham == dtl?.preMaSanPham || !dtl?.preMaSanPham) // chọn lại sản phẩm khác!
                //     ? dtl?.cost
                //     : findPM?.giaBanSi,
                tienSP: dtl.amount ? dtl.cost : '',
                spTP: !dtl.amount ? 1 : 0,
                preMaSanPham: dtl?.maSanPham,
                isRequireSP: findPM?.input || 0
              });
            }
          }
        }
      }

      return tempList || [];
    } else {
      const listProMix = [...productCategoryPMP, ...productCategoryPMS];
      // const detail = createOrders['rowSelected']?.DeviceList;

      const tempDetail = [...detail].map((item: any, index: number) => ({
        Key: item.maSanPhamMoi + item.cost + item.registrationPlate,
        child: {
          ...item
        }
      }));

      // bước tiếp theo là tiến hành gom các chi tiết có cùng bs cũ -> bs mới lại với nhau với child chứa các chi tiết bên trong đó
      // lưu ý là phải đúng với format bên form update
      const mergeList = new Map(tempDetail.map(({ Key, child }) => [Key, { Key, child: [] }]));
      for (const { Key, child } of tempDetail) mergeList.get(Key)?.child.push(...[child].flat());
      const tempList: any = [];
      for (let i = 0; i < [...mergeList.values()]?.length; i++) {
        const obj = {
          ...[...mergeList.values()][i]
        };

        if ([...mergeList.values()][i].child?.length != 0) {
          const childFirst = {
            ...[...mergeList.values()][i].child[0]
          };
          const findPM = listProMix.find(proMix => proMix.maSanPham == childFirst?.maSanPhamMoi);

          if (findPM?.input === 0) {
            // cần xử lý vụ id tại đây
            // phần để xử lý ids nếu cần giữ lại id gửi lên, đây bán phụ kiện mới có sl nên k cần xử lý ids list này
            const listID: any = [...mergeList.values()][i]?.child.map(ch => ch.id || 0);
            const costValue =
              (obj.child[0]?.cost === null || obj.child[0]?.cost !== undefined || obj.child[0]?.cost == 0) && // cho phép giá 0, giá mà undefined là để và có báo lỗi, còn giá mà null là ngt a xoá hết input cứ để đó là báo lỗi input rỗng
              obj.child[0]?.cost != findPM?.giaBanSi && // giá nhập khác giá gốc sp
              (obj.child[0]?.maSanPhamMoi == obj.child[0]?.preMaSanPham || !obj.child[0]?.preMaSanPham) // chọn lại sản phẩm khác!
                ? obj.child[0]?.cost
                : findPM?.giaBanSi;

            const vatValue =
              obj.child[0]?.vatValue !== null && obj.child[0]?.vatValue !== undefined && obj.child[0]?.vatValue !== 0
                ? obj.child[0]?.vatValue
                : findPM?.vatValue;

            obj.child[0]['ids'] = [...listID, ...([...mergeList.values()][i]?.child[0]['ids'] || [])].filter(function (
              item,
              index,
              arr
            ) {
              return arr.indexOf(item) === index;
            });

            obj.child[0]['isRequireSP'] = findPM?.input || 0;
            obj.child[0]['amount'] =
              (obj.child[0]['amount'] || 0) + (obj.child?.length - ((obj.child[0]['amount'] && 1) || 0));
            obj.child[0]['cost'] = +costValue;
            obj.child[0]['preMaSanPham'] = obj.child[0]?.maSanPhamMoi;
            obj.child[0]['vatValue'] = vatValue || 0;
            obj.child[0]['priceAfterVat'] = +costValue + (+costValue * +vatValue) / 100 || 0;
            tempList.push({ ...obj.child[0] });
          } else {
            for (let j = 0; j < [...mergeList.values()][i].child.length; j++) {
              const dtl = [...mergeList.values()][i].child[j];

              const costValue =
                !dtl.old && !uLogin.ActionOrder.editWillPay
                  ? 0
                  : (dtl?.cost === null || dtl?.cost !== undefined || dtl?.cost == 0) && // cho phép giá 0, giá mà undefined là để và có báo lỗi, còn giá mà null là ngt a xoá hết input cứ để đó là báo lỗi input rỗng
                    dtl?.cost != findPM?.giaBanSi && // giá nhập khác giá gốc sp
                    (dtl?.maSanPhamMoi == dtl?.preMaSanPham || !dtl?.preMaSanPham) // chọn lại sản phẩm khác!
                  ? dtl?.cost
                  : findPM?.giaBanSi;

              const vatValue =
                dtl?.vatValue !== null && dtl?.vatValue !== undefined && dtl?.vatValue !== 0
                  ? dtl?.vatValue
                  : findPM?.vatValue;

              tempList.push({
                ...[...mergeList.values()][i].child[j],
                cost: costValue,
                preMaSanPham: dtl?.maSanPhamMoi,
                isRequireSP: findPM?.input || 0,

                vatValue: vatValue || 0,
                priceAfterVat: +costValue + (+costValue * +vatValue) / 100 || 0
              });
            }
          }
        }
      }

      return tempList || [];
    }
  };

  useEffect(() => {
    const data = createOrders['dataBody'];
    const row = createOrders['rowSelected'];
    const orderTypeId = Number(data?.orderTypeId);

    // 1. Ưu tiên xử lý dataBody
    if (data) {
      if (data.detailItems) return setOrder(proccessProductUG(data.detailItems, true, orderTypeId));
      if (data.ThuNoItems) return setOrder(proccessProductUG(data.ThuNoItems, true, orderTypeId));
      if (data.diff) return setOrder(proccessProductChenhLech(data.diff));
      if (data.items) {
        const isSpecialType = orderTypeId === 3;
        const processedItems = isSpecialType ? convertOrder(data.items, 'taodontp') : data.items;
        return setOrder(proccessProductUG(processedItems, orderTypeId === 7 || isSpecialType));
      }
      if (data.errors) return setOrder(proccessProductUG(data.errors));
      return; // Thoát nếu có dataBody nhưng không khớp item nào
    }

    // 2. Xử lý rowSelected nếu không có dataBody
    if (row) {
      if (row.orderDetails) return setOrder(proccessProductUG(row.orderDetails));
      if (row.ThuNoItems) return setOrder(proccessProductUG(row.ThuNoItems, true, row.orderType.id));
      if (row.debtOrderDetails) return setOrder(proccessProductUG(row.debtOrderDetails));
      if (row.errorList) return setOrder(proccessProductUG(row.errorList));
      if (row.detailItems) return setOrder(proccessProductUG(row.detailItems));
      if (row.itemDetails) return setOrder(proccessProductUG(gomSLHangGui(row.itemDetails)));
      if (row.upgradeDetails) return setOrder(proccessProductUG(convertOrder(row.upgradeDetails, 'nc'), true));
      if (row.DeviceList) return setOrder(proccessProductUG(convertOrder(row.DeviceList, 'tp'), true));
    }

    // 3. Cuối cùng mới xét valueDetails
    if (createOrders['valueDetails']) {
      setOrder(proccessProductUG(createOrders['valueDetails']));
    }
  }, [createOrders]);

  const gomSLHangGui = (product: any[]) => {
    const listProMix = [...productCategoryPMP, ...productCategoryPMS];
    const arr = [];
    for (let i = 0; i < product.length; i++) {
      const findPM = listProMix.find(
        proMix =>
          proMix.maSanPham == product[i]?.maSanPhamMoi ||
          proMix.maSanPham == product[i]?.maSanPham ||
          proMix.maSanPham == product[i]?.newMaSanPham
      );
      const findPMCu = listProMix.find(
        proMix => proMix.maSanPham == product[i]?.maSanPhamCu || proMix.maSanPham == product[i]?.oldMaSanPham
      );
      arr.push({
        ...product[i],
        cost:
          (product[i]?.cost == undefined || product[i]?.cost == null) &&
          product[i]?.cost != 0 &&
          product[i]?.maSanPhamMoi != product[i]?.preMaSanPham
            ? findPM?.giaBanSi
            : product[i]?.cost,
        tenSanPham: findPM?.nameDisplay,
        tenSanPhamCu: findPMCu?.nameDisplay,
        preMaSanPham: product[i]?.maSanPhamMoi,
        isRequireSP: findPM?.input || 0
      });
    }
    return (
      arr.reduce((acc, curr) => {
        const supplieruuid = curr['tenSanPham'];
        // curr['tenBo'] !== '' ? `${curr['tenSanPham']} (${curr['tenBo']})` : `${curr['tenSanPham']}`;
        const objInAcc = acc.find(o => o.title === supplieruuid);
        if (objInAcc) objInAcc.data.push(curr);
        else acc.push({ title: supplieruuid, data: [curr] });
        return acc;
      }, []) || []
    );
  };

  const proccessProductChenhLech = (product: any[], removeDup?: boolean, type?: number) => {
    if (!product) return [];

    // Bước 1: Gom nhóm bằng reduce
    // let processedList = product;

    // Bước 2: Map để bổ sung thông tin hiển thị (Tên SP, Thuế, Giá sau thuế)
    return (
      product.map(dtl => {
        return {
          ...dtl
        };
      }) || []
    );
  };

  const proccessProductUG = (product: any[], removeDup?: boolean, type?: number) => {
    if (type === 12) {
      const listProMix = [...productCategoryPMP, ...productCategoryPMS];

      if (!product) return [];

      // Bước 1: Gom nhóm bằng reduce
      let processedList = product;

      if (removeDup) {
        processedList = product.reduce((acc: any[], item: any) => {
          const maSP = item.maSanPham || '';
          const tenSP = item.tenSanPham || '';
          const maBo = item.maBo || '';
          const cost = item.cost || 0;
          const key = `${maSP}-${tenSP}-${maBo}-${cost}`;

          const existingItem = acc.find(obj => {
            const objKey = `${obj.maSanPham || ''}-${obj.tenSanPham || ''}-${obj.maBo || ''}-${obj.cost || 0}`;
            return objKey === key;
          });

          // SỬA TẠI ĐÂY: Kiểm tra item hiện tại có serial/phone không
          // Nếu có thì dù quantity trong data là bao nhiêu cũng chỉ tính là 1
          const isIdentify = (item.phone && item.phone !== '') || (item.serial && item.serial !== '');
          const currentQty = isIdentify ? 1 : Number(item.quantity) || 1;

          if (existingItem) {
            existingItem.quantity = (Number(existingItem.quantity) || 0) + currentQty;

            if (item.phone)
              existingItem.phone = existingItem.phone ? `${existingItem.phone}, ${item.phone}` : item.phone;
            if (item.serial)
              existingItem.serial = existingItem.serial ? `${existingItem.serial}, ${item.serial}` : item.serial;
          } else {
            acc.push({
              ...item,
              quantity: currentQty
            });
          }

          return acc;
        }, []);
      }

      // Bước 2: Map để bổ sung thông tin hiển thị (Tên SP, Thuế, Giá sau thuế)
      return (
        processedList.map(dtl => {
          const findPM = listProMix.find(
            proMix =>
              proMix.maSanPham == dtl?.maSanPhamMoi ||
              proMix.maSanPham == dtl?.maSanPham ||
              proMix.maSanPham == dtl?.newMaSanPham
          );

          const findPMCu = listProMix.find(
            proMix => proMix.maSanPham == dtl?.maSanPhamCu || proMix.maSanPham == dtl?.oldMaSanPham
          );

          // Xử lý giá: Nếu không có giá và đổi mã sản phẩm thì lấy giá bán sỉ từ danh mục
          const costValue =
            (dtl?.cost === undefined || dtl?.cost === null) && dtl?.maSanPhamMoi != dtl?.preMaSanPham
              ? findPM?.giaBanSi
              : dtl?.cost;

          const vatValue =
            dtl?.vatValue !== null && dtl?.vatValue !== undefined && dtl?.vatValue !== 0
              ? dtl?.vatValue
              : findPM?.vatValue;

          return {
            ...dtl,
            cost: costValue || 0,
            totalCost: dtl?.cost * dtl?.quantity,
            tenSanPham: findPM?.nameDisplay || dtl?.tenSanPham,
            tenSanPhamCu: findPMCu?.nameDisplay || dtl?.tenSanPhamCu,
            preMaSanPham: dtl?.maSanPhamMoi,
            isRequireSP: findPM?.input || 0,
            vatValue: vatValue || 0,
            priceAfterVat: Number(costValue) + (Number(costValue) * Number(vatValue)) / 100 || 0
          };
        }) || []
      );
    } else if (type === 11) {
      const dataConvert = product[0].inDebtOrderCodes || [];

      const result = dataConvert
        .filter(item => item.checked === true)
        .map(item => {
          // Hàm nội bộ để xử lý gom mảng/chuỗi thành 1 chuỗi hiển thị duy nhất
          const formatDisplay = value => {
            if (!value) return '---';
            // Nếu value là mảng (từ childItems), hoặc chuỗi có dấu phẩy/chấm phẩy
            const rawStr = Array.isArray(value) ? value.join(', ') : value.toString();

            // Tách ra, lọc bỏ khoảng trống, xóa trùng và nối lại
            const cleanArray = Array.from(
              new Set(
                rawStr
                  .split(/[;,]/)
                  .map(s => s.trim())
                  .filter(Boolean)
              )
            );

            return cleanArray.length > 0 ? cleanArray.join(', ') : '---';
          };

          return {
            maDonHang: item.maDonHang,
            // Hiển thị biển số và serial gọn gàng trên 1 dòng
            bienSoXe: formatDisplay(item.bienSoXe),
            serial: formatDisplay(item.serial),
            thuVat: item.thuVat || 0,
            thuChenhLech: item.thuChenhLech || 0,

            // Các trường dữ liệu cũ của bạn
            tienNo: (item.tongTienDonNo || item.tienNo || 0) + (item.goiCuoc || 0),
            tongTienDonNo: item.tongTienDonNo || item.tienNo || 0,
            goiCuoc: item.goiCuoc || 0,
            staffCreate: item.staffCreate || item.nguoiTao,
            ngay: item.ngay ? item.ngay : '-',

            // Thêm thông tin bổ sung nếu cần hiển thị trên Modal
            loai: item.loai || item.orderType
          };
        });

      return result || [];
    } else {
      const listProMix = [...productCategoryPMP, ...productCategoryPMS];

      return (
        product
          ?.filter(function (item: any, index: any, arr) {
            return removeDup
              ? item.amount
                ? arr.findIndex(
                    obj2 =>
                      (obj2.maSanPham || obj2.maSanPhamMoi) + (obj2.registrationPlate || obj2.bs) + obj2.cost ===
                      (item.maSanPham || item.maSanPhamMoi) + (item.registrationPlate || item.bs) + item.cost
                  ) === index
                : true
              : true;
          })
          .map(dtl => {
            const findPM = listProMix.find(
              proMix =>
                proMix.maSanPham == dtl?.maSanPhamMoi ||
                proMix.maSanPham == dtl?.maSanPham ||
                proMix.maSanPham == dtl?.newMaSanPham
            );
            const findPMCu = listProMix.find(
              proMix => proMix.maSanPham == dtl?.maSanPhamCu || proMix.maSanPham == dtl?.oldMaSanPham
            );

            const costValue =
              (dtl?.cost == undefined || dtl?.cost == null) && dtl?.cost != 0 && dtl?.maSanPhamMoi != dtl?.preMaSanPham
                ? findPM?.giaBanSi
                : dtl?.cost;

            const vatValue =
              dtl?.vatValue !== null && dtl?.vatValue !== undefined && dtl?.vatValue !== 0
                ? dtl?.vatValue
                : findPM?.vatValue;

            return {
              ...dtl,
              cost: costValue,
              tenSanPham: findPM?.nameDisplay,
              tenSanPhamCu: findPMCu?.nameDisplay,
              preMaSanPham: dtl?.maSanPhamMoi,
              isRequireSP: findPM?.input || 0,

              vatValue: vatValue || 0,

              priceAfterVat: +costValue + (+costValue * +vatValue) / 100 || 0
            };
          }) || []
      );
    }
  };

  // eslint-disable-next-line
  const fullTypeOrder = [
    'Hàng gửi',
    'Lắp mới',
    'Thu phí',
    'Sửa chữa',
    'Bảo hành',
    'Thu đổi',
    'Nâng cấp',
    'Tháo - Lắp lại',
    'ĐL lắp giùm',
    'Lắp giùm ĐL',
    'Thu nợ',
    'Trả hàng',
    'Chênh lệch'
  ];
  const tagTLL = ['Tháo', 'Lắp lại', 'Tháo - Lắp lại'];
  const chiNhanh = ['Hồ Chí Minh', 'Cần Thơ', 'Đà Nẵng', 'Hà Nội', 'Bình Minh'];
  const handleCancel = () => {
    dispatch(updateOpenCreateModal(false));
  };

  const modalRender = useMemo(() => {
    return (
      <>
        {arrayBS !== undefined && arrayBS.length > 0 ? (
          <div>
            <Modal
              title="Các đơn trùng biển số"
              visible={isModalOpen}
              onOk={handleOk}
              cancelButtonProps={{ style: { display: 'none' } }}
              onCancel={handleCancel1}
              width={700}
            >
              <div className="flex flex-col">
                {arrayBS.map((e, index) => {
                  return (
                    <div key={index}>
                      <span className="font-semibold">{`${index + 1}/ Biển số: `}</span> <span>{` ${e.bs} | `}</span>
                      <span className="font-semibold">Mã ĐH: </span> <span>{`${e.maDonHang} | `}</span>
                      <span className="font-semibold">Thời gian:</span>
                      <span>{` ${moment(new Date(e.thoiGianTao)).format('DD/MM/YYYY H:mm')} | `}</span>
                      <span className="font-semibold">NV tạo: </span> <span>{`${e.staffCreate} `}</span>
                    </div>
                  );
                })}
              </div>
            </Modal>
          </div>
        ) : (
          ''
        )}
      </>
    );
  }, [arrayBS, isModalOpen]);

  const textModal = useMemo(() => {
    return (
      <>
        {arrayBS !== undefined && arrayBS.length > 0 ? (
          <div>
            <div className="flex items-center">
              <span className=" uppercase font-semibold text-[14px] text-red-500">
                {`Biển số ${arrayBS[0]?.bs} đã được tạo ở đơn hàng khác, bạn có muốn tạo đơn mới?`}
              </span>
              {arrayBS.length > 1 ? (
                <Button className="ml-2" onClick={showModal}>
                  Xem thêm {arrayBS.length - 1} đơn
                </Button>
              ) : (
                ''
              )}
            </div>
            <Divider style={{ marginTop: 5, marginBottom: 5 }} />
          </div>
        ) : (
          ''
        )}
      </>
    );
  }, [arrayBS]);
  const renderListOrder = useMemo(() => {
    const columnsTD = [
      {
        title: 'Tên sản phẩm',
        dataIndex: 'tenSanPham',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Số lượng',
        dataIndex: 'quantity'
      }
    ];
    const columns = [
      {
        title: 'Tên sản phẩm',
        dataIndex: 'tenSanPham',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Serial',
        dataIndex: 'serial',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Số điện thoại',
        dataIndex: 'phone',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Số lượng',
        dataIndex: 'amount'
      },

      {
        title: 'VAT',
        dataIndex: 'vatValue',

        render: text => <span>{createOrders['dataBody']?.orderVat || createOrders['body']?.orderVat ? text : 0}</span>
      },
      {
        title: 'Giá có VAT',
        dataIndex: 'priceAfterVat',
        render: text => (
          <span>
            {createOrders['dataBody']?.orderVat || createOrders['body']?.orderVat
              ? !text
                ? Helpers.FormatMoney(0)
                : Helpers.FormatMoney(text)
              : 0}
          </span>
        )
      }
    ];
    const columnsHG = [
      {
        title: 'Tên sản phẩm',
        dataIndex: 'title',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Số lượng',
        dataIndex: 'data',
        render: text => <span>{!text ? '-' : text?.length}</span>
      }
    ];
    const columnsTH = [
      {
        title: 'Mã trang ',
        dataIndex: 'oldCompanyId',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Đội xe ',
        dataIndex: 'oldDoiXe',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Biển số ',
        dataIndex: 'oldRegistrationPlate',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Sản phẩm cũ',
        dataIndex: 'maSanPham',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Sản phẩm mới',
        dataIndex: 'maSanPhamMoi',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Giá tiền',
        dataIndex: 'cost',
        render: text => <span>{!text ? Helpers.FormatMoney(0) : Helpers.FormatMoney(text)}</span>
      },

      {
        title: 'VAT',
        dataIndex: 'vatValue',

        render: text => <span>{createOrders['dataBody']?.orderVat || createOrders['body']?.orderVat ? text : 0}</span>
      },
      {
        title: 'Giá có VAT',
        dataIndex: 'priceAfterVat',
        render: text => (
          <span>
            {createOrders['dataBody']?.orderVat || createOrders['body']?.orderVat
              ? !text
                ? Helpers.FormatMoney(0)
                : Helpers.FormatMoney(text)
              : 0}
          </span>
        )
      }
    ];

    const columnsTL = [
      {
        title: 'Mã trang mới',
        dataIndex: 'newCompanyId',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Đội xe mới',
        dataIndex: 'newDoiXe',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Biển số mới',
        dataIndex: 'newRegistrationPlate',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Sản phẩm cũ',
        dataIndex: 'maSanPham',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Sản phẩm mới',
        dataIndex: 'maSanPhamMoi',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Giá tiền',
        dataIndex: 'cost',
        render: text => <span>{!text ? Helpers.FormatMoney(0) : Helpers.FormatMoney(text)}</span>
      },

      {
        title: 'VAT',
        dataIndex: 'vatValue',

        render: text => <span>{createOrders['dataBody']?.orderVat || createOrders['body']?.orderVat ? text : 0}</span>
      },
      {
        title: 'Giá có VAT',
        dataIndex: 'priceAfterVat',
        render: text => (
          <span>
            {createOrders['dataBody']?.orderVat || createOrders['body']?.orderVat
              ? !text
                ? Helpers.FormatMoney(0)
                : Helpers.FormatMoney(text)
              : 0}
          </span>
        )
      }
    ];
    const columnsTLL = [
      {
        title: 'Mã trang',
        dataIndex: 'oldCompanyId',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Đội xe',
        dataIndex: 'oldDoiXe',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Biển số',
        dataIndex: 'oldRegistrationPlate',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Mã trang mới',
        dataIndex: 'newCompanyId'
      },
      {
        title: 'Đội xe mới',
        dataIndex: 'newDoiXe',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Biển số mới',
        dataIndex: 'newRegistrationPlate',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Sản phẩm cũ',
        dataIndex: 'maSanPham',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Sản phẩm mới',
        dataIndex: 'maSanPhamMoi',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Giá tiền',
        dataIndex: 'cost',
        render: text => <span>{!text ? Helpers.FormatMoney(0) : Helpers.FormatMoney(text)}</span>
      },

      {
        title: 'VAT',
        dataIndex: 'vatValue',

        render: text => <span>{createOrders['dataBody']?.orderVat || createOrders['body']?.orderVat ? text : 0}</span>
      },
      {
        title: 'Giá có VAT',
        dataIndex: 'priceAfterVat',
        render: text => (
          <span>
            {createOrders['dataBody']?.orderVat || createOrders['body']?.orderVat
              ? !text
                ? Helpers.FormatMoney(0)
                : Helpers.FormatMoney(text)
              : 0}
          </span>
        )
      }
    ];
    const columnsSC = [
      {
        title: 'Mã Trang',
        dataIndex: 'companyId',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Đội xe',
        dataIndex: 'doiXe',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Biển số',
        dataIndex: 'registrationPlate',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Loại xe',
        dataIndex: 'vehicleType',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Hạn đăng kiểm',
        dataIndex: 'hanDangKiem',
        render: text => <span>{!text ? '-' : moment(new Date(text)).format('DD/MM/YYYY')}</span>
      },
      {
        title: 'Mã thiết bị',
        dataIndex: 'tenSanPhamCu',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Mã thiết bị mới',
        dataIndex: 'tenSanPham',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Lỗi ghi nhận',
        dataIndex: 'errorTpye',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Giá thiết bị',
        dataIndex: 'cost',
        render: text => <span>{!text ? Helpers.FormatMoney(0) : Helpers.FormatMoney(text)}</span>
      },

      {
        title: 'VAT',
        dataIndex: 'vatValue',

        render: text => <span>{createOrders['dataBody']?.orderVat || createOrders['body']?.orderVat ? text : 0}</span>
      },
      {
        title: 'Giá có VAT',
        dataIndex: 'priceAfterVat',
        render: text => (
          <span>
            {createOrders['dataBody']?.orderVat || createOrders['body']?.orderVat
              ? !text
                ? Helpers.FormatMoney(0)
                : Helpers.FormatMoney(text)
              : 0}
          </span>
        )
      }
    ];
    const columnsTP = [
      {
        title: 'Mã Trang',
        dataIndex: 'companyId',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Đội xe',
        dataIndex: 'doiXe',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Biển số',
        dataIndex: 'bs',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Mã sản phẩm',
        dataIndex: 'maSanPham'
      },
      {
        title: 'Tiền phí & Tiền SP',
        dataIndex: 'cost',
        render: text => <span>{!text ? Helpers.FormatMoney(0) : Helpers.FormatMoney(text)}</span>
      },
      {
        title: 'Gói cước',
        dataIndex: 'servicePackName',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Số lượng cam',
        dataIndex: 'cameraCount'
      },
      {
        title: 'Số lượng SP',
        dataIndex: 'amount',
        render: text => <span>{!text ? '1' : text}</span>
      },
      {
        title: 'Tổng tiền SP',
        dataIndex: 'tienSP',
        render: (text, record) => {
          return (
            <span>{!text && record.spTP === 1 ? '–' : !text ? Helpers.FormatMoney(0) : Helpers.FormatMoney(text)}</span>
          );
        }
      },

      {
        title: 'VAT',
        dataIndex: 'vatValue',

        render: text => <span>{createOrders['dataBody']?.orderVat || createOrders['body']?.orderVat ? text : 0}</span>
      },
      {
        title: 'Giá có VAT',
        dataIndex: 'priceAfterVat',
        render: text => (
          <span>
            {createOrders['dataBody']?.orderVat || createOrders['body']?.orderVat
              ? !text
                ? Helpers.FormatMoney(0)
                : Helpers.FormatMoney(text)
              : 0}
          </span>
        )
      }
    ];
    const columnsNC = [
      {
        title: 'Mã Trang',
        dataIndex: 'companyId',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Đội xe',
        dataIndex: 'doiXe',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Biển số',
        dataIndex: 'registrationPlate',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Loại xe',
        dataIndex: 'vehicleType',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Hạn đăng kiểm',
        dataIndex: 'hanDangKiem',
        render: text => <span>{!text ? '-' : moment(new Date(text)).format('DD/MM/YYYY')}</span>
      },
      {
        title: 'Mã thiết bị cũ',
        dataIndex: 'tenSanPhamCu',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Mã thiết bị mới',
        dataIndex: 'tenSanPham',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Số lượng',
        dataIndex: 'amount',
        render: text => <span>{!text ? '1' : text}</span>
      },
      {
        title: 'Giá tiền',
        dataIndex: 'cost',
        render: text => <span>{!text ? Helpers.FormatMoney(0) : Helpers.FormatMoney(text)}</span>
      },

      {
        title: 'VAT',
        dataIndex: 'vatValue',

        render: text => <span>{createOrders['dataBody']?.orderVat || createOrders['body']?.orderVat ? text : 0}</span>
      },
      {
        title: 'Giá có VAT',
        dataIndex: 'priceAfterVat',
        render: text => (
          <span>
            {createOrders['dataBody']?.orderVat || createOrders['body']?.orderVat
              ? !text
                ? Helpers.FormatMoney(0)
                : Helpers.FormatMoney(text)
              : 0}
          </span>
        )
      }
    ];
    const columnsDLLG = [
      {
        title: 'Mã Trang',
        dataIndex: 'companyId',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Đội xe',
        dataIndex: 'doiXe',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Biển số',
        dataIndex: 'registrationPlate',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Loại xe',
        dataIndex: 'vehicleType',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Hạn đăng kiểm',
        dataIndex: 'hanDangKiem',
        render: text => <span>{!text ? '-' : moment(new Date(text)).format('DD/MM/YYYY')}</span>
      },
      {
        title: 'Tên sản phẩm',
        dataIndex: 'tenSanPham',
        render: text => <span>{!text ? '-' : text}</span>
      },

      {
        title: 'VAT',
        dataIndex: 'vatValue',

        render: text => <span>{createOrders['dataBody']?.orderVat || createOrders['body']?.orderVat ? text : 0}</span>
      },
      {
        title: 'Giá có VAT',
        dataIndex: 'priceAfterVat',
        render: text => (
          <span>
            {createOrders['dataBody']?.orderVat || createOrders['body']?.orderVat
              ? !text
                ? Helpers.FormatMoney(0)
                : Helpers.FormatMoney(text)
              : 0}
          </span>
        )
      }
    ];

    const columnsTHang = [
      {
        title: 'Tên sản phẩm',
        dataIndex: 'tenSanPham',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Số lượng SP',
        dataIndex: 'quantity',
        render: text => <span>{!text ? '1' : text}</span>
      },
      {
        title: 'Tiền SP',
        dataIndex: 'cost',
        render: (text, record) => {
          return (
            <span>{!text && record.spTP === 1 ? '–' : !text ? Helpers.FormatMoney(0) : Helpers.FormatMoney(text)}</span>
          );
        }
      },
      {
        title: 'Tổng tiền',
        dataIndex: 'totalCost',
        render: (text, record) => {
          return <span>{!text ? Helpers.FormatMoney(0) : Helpers.FormatMoney(text)}</span>;
        }
      }
    ];

    const columnsThuNo = [
      {
        title: 'Mã đơn hàng',
        dataIndex: 'maDonHang',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Loại đơn',
        dataIndex: 'loai',
        render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Gói cước',
        dataIndex: 'goiCuoc',
        render: (text, record) => {
          return <span>{!text ? Helpers.FormatMoney(0) : Helpers.FormatMoney(text)}</span>;
        }
      },
      {
        title: 'Thu VAT',
        dataIndex: 'thuVat',
        render: (text, record) => {
          return <span>{!text ? Helpers.FormatMoney(0) : Helpers.FormatMoney(text)}</span>;
        }
      },
      {
        title: 'Chênh lệch',
        dataIndex: 'thuChenhLech',
        render: (text, record) => {
          return <span>{!text ? Helpers.FormatMoney(0) : Helpers.FormatMoney(text)}</span>;
        }
      },
      {
        title: 'Tiền nợ',
        // dataIndex: 'tongTienDonNo',
        dataIndex: 'tienNo',
        render: (text, record) => {
          return <span>{!text ? Helpers.FormatMoney(0) : Helpers.FormatMoney(text)}</span>;
        }
      },
      {
        title: 'Người tạo',
        dataIndex: 'staffCreate'
      },
      {
        title: 'TG hoàn thành',
        dataIndex: 'ngay'
      }
    ];

    const columnsChenhLech = [
      {
        title: 'Số hóa đơn',
        dataIndex: 'soHoaDon'
        // render: text => <span>{!text ? '-' : text}</span>
      },
      {
        title: 'Tiền chênh lệch',
        dataIndex: 'thuChenhLech',
        render: (text, record) => {
          return <span> {!text ? Helpers.FormatMoney(0) : Helpers.FormatMoney(text)}</span>;
        }
      }
    ];

    if (!createOrders['body']) {
      return (
        <div>
          {modalRender}
          <div className="p-3 bg-gray-50 rounded-t-lg border border-b-0 text-[13px]">
            <div className="grid grid-cols-4 gap-4 mb-3 pb-2 border-b border-gray-200">
              <div>
                <div className="text-gray-500 text-[11px] uppercase tracking-wider">
                  {t('OrganizedSales.OrderManager.CorfirmOrder.TypeOrder')}
                </div>
                <div className="font-bold text-red-600 uppercase">
                  {fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] === 'Tháo - Lắp lại'
                    ? `${fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1]} (${
                        tagTLL[Number(createOrders['dataBody']?.thaoLapTag) - 1]
                      })`
                    : fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1]}
                </div>
              </div>
              <div>
                <div className="text-gray-500 text-[11px] uppercase tracking-wider">
                  {t('OrganizedSales.OrderManager.CorfirmOrder.BranchWork')}
                </div>
                <div className="font-bold text-red-600 uppercase">
                  {chiNhanh[Number(createOrders['chiNhanh']) - 1] || ''}
                </div>
              </div>
              <div>
                <div className="text-gray-500 text-[11px] uppercase tracking-wider">
                  {t('OrganizedSales.OrderManager.CorfirmOrder.TimeDeli')}
                </div>
                <div className="font-semibold">
                  {createOrders?.keyOrder !== 12 && createOrders?.keyOrder !== 13
                    ? moment(new Date(createOrders['dataBody']?.thoiGianHenLap || ''))
                        .subtract(7, 'hours')
                        .format('HH:mm DD/MM/YYYY')
                    : '--'}
                </div>
              </div>
              <div>
                <div className="text-gray-500 text-[11px] uppercase tracking-wider">
                  {t('OrganizedSales.OrderManager.CorfirmOrder.CoopType')}
                </div>
                <div className="font-bold text-red-600 uppercase">
                  {itemTypeCoop?.find(i => i.value === createOrders?.['dataBody']?.cooperationTypeId)?.label || ''}
                </div>
              </div>
            </div>

            {/* Hàng 2: Khách hàng & Tài chính (Chia 4 cột) */}
            <div className="grid grid-cols-4 gap-6 items-start">
              {/* Thông tin KH - Chiếm 2 cột đầu */}
              <div className="col-span-2 grid grid-cols-2 gap-y-1 gap-x-4 border-r pr-4">
                <div className="col-span-1">
                  <span className="font-semibold">{t('OrganizedSales.OrderManager.CorfirmOrder.NameCus')}: </span>
                  <span>{createOrders['dataBody']?.customerName || ''}</span>
                </div>
                <div className="col-span-1">
                  <span className="font-semibold">{t('OrganizedSales.OrderManager.CorfirmOrder.PhoneCus')}: </span>
                  <span className="text-red-500">{createOrders['dataBody']?.customerPhone || ''}</span>
                </div>
                <div className="col-span-1">
                  <span className="font-semibold">{t('OrganizedSales.OrderManager.CorfirmOrder.NameCusLH')}: </span>
                  <span>{createOrders['dataBody']?.tenNguoiLienHe || ''}</span>
                </div>
                <div className="col-span-1">
                  {createOrders['dataBody']?.sdtLienHe && (
                    <>
                      <span className="font-semibold">
                        {t('OrganizedSales.OrderManager.CorfirmOrder.PhoneCusLH')}:{' '}
                      </span>
                      <span className="text-red-500">{createOrders['dataBody']?.sdtLienHe}</span>
                    </>
                  )}
                </div>
                <div className="col-span-2 mt-1">
                  <span className="font-semibold">{t('OrganizedSales.OrderManager.CorfirmOrder.Address')}: </span>
                  <span className="text-gray-600 italic">{createOrders['dataBody']?.orderAddress?.address || ''}</span>
                </div>
              </div>

              {/* Phương thức & Giao dịch - Cột 3 */}
              <div className="col-span-1 space-y-2">
                <div>
                  <span className="font-semibold">{t('OrganizedSales.OrderManager.CorfirmOrder.Method')}: </span>
                  <span className="text-red-600 font-medium uppercase">
                    {createOrders['dataBody']?.hinhThucThanhToan || ''}
                  </span>
                </div>
                {createOrders?.keyOrder !== 11 && (
                  <div>
                    <span className="font-semibold">{t('OrganizedSales.OrderManager.CorfirmOrder.VAT')}: </span>
                    <span className="text-red-600">{createOrders['dataBody']?.orderVat ? 'Có' : 'Không'}</span>
                  </div>
                )}
                {createOrders?.keyOrder === 11 && (
                  <div className="bg-blue-50 p-1.5 rounded border border-blue-100 text-[12px]">
                    <div>
                      <b>{t('OrganizedSales.OrderManager.CorfirmOrder.MaGD')}:</b>{' '}
                      {createOrders['dataBody']?.ngayGiaoDich
                        ? dayjs(createOrders['dataBody']?.ngayGiaoDich).format('DD-MM-YYYY')
                        : createOrders['dataBody']?.maGiaoDich
                        ? dayjs(createOrders['dataBody']?.maGiaoDich).format('DD-MM-YYYY')
                        : ''}
                    </div>
                    <div className="truncate">
                      <b>Nội dung:</b> {createOrders['dataBody']?.noiDungChuyenKhoan}
                    </div>
                    <div className="text-orange-700 font-bold mt-1 uppercase text-[11px]">
                      {t('OrganizedSales.OrderManager.CorfirmOrder.DuNo')}:{' '}
                      {Helpers.FormatMoney(createOrders['dataBody']?.duNoKhachHang) || 0}
                    </div>
                  </div>
                )}
              </div>

              {/* Tài chính tổng - Cột 4 */}
              <div className="col-span-1 bg-white p-2 rounded shadow-sm border border-gray-200 text-right">
                <div className="mb-2">
                  <span className="text-[10px] text-gray-400 block uppercase font-bold">
                    {t('OrganizedSales.OrderManager.CorfirmOrder.MoneyWill')}
                  </span>
                  <span className="text-lg font-bold text-blue-600">
                    {Helpers.FormatMoney(uLogin?.role === 'Technician' ? 0 : createOrders['dataBody']?.tienThanhToan) ||
                      0}
                  </span>
                </div>
                <div className="pt-1 border-t border-gray-100">
                  <span className="text-[10px] text-gray-400 block uppercase font-bold">
                    {t('OrganizedSales.OrderManager.CorfirmOrder.MoneyPayed')}
                  </span>
                  <span className="text-lg font-bold text-green-600">
                    {Helpers.FormatMoney(createOrders['dataBody']?.tienThucThu) || 0}
                  </span>
                </div>
              </div>
            </div>

            {/* Thông tin VAT (Toàn bộ chiều ngang nếu có) */}
            {createOrders['dataBody']?.orderVat?.mst !== '' && (
              <div className="mt-2 p-1.5 text-[12px] flex items-center space-x-3">
                {/* Nhãn tiêu đề nhỏ gọn */}
                <div className="font-bold text-red-600 uppercase whitespace-nowrap border-r border-red-200 pr-3">
                  VAT
                </div>

                {/* Nội dung trên 1 hàng */}
                <div className="flex flex-1 items-center space-x-4 overflow-hidden">
                  <div className="whitespace-nowrap">
                    <span className="font-semibold text-gray-500">MST:</span> {createOrders['dataBody']?.orderVat?.mst}
                  </div>

                  <span className="text-red-200">|</span>

                  <div className="truncate min-w-[150px]">
                    <span className="font-semibold text-gray-500">Công ty:</span>{' '}
                    {createOrders['dataBody']?.orderVat?.tenCongTy}
                  </div>

                  <span className="text-red-200">|</span>

                  <div className="whitespace-nowrap">
                    <span className="font-semibold text-gray-500">Email:</span>{' '}
                    {createOrders['dataBody']?.orderVat?.email}
                  </div>

                  <span className="text-red-200">|</span>

                  <div className="truncate flex-1">
                    <span className="font-semibold text-gray-500">Địa chỉ:</span>{' '}
                    {createOrders['dataBody']?.orderVat?.address}
                  </div>
                </div>
              </div>
            )}
          </div>

          <div>
            <h3 className="ml-1">SẢN PHẨM: </h3>
            <Table
              scroll={{ y: heigth > 899 ? 400 : 200 }}
              columns={
                fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Nâng cấp'
                  ? columnsNC
                  : fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'ĐL lắp giùm'
                  ? columnsDLLG
                  : fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Trả hàng'
                  ? columnsTHang
                  : fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Thu nợ'
                  ? columnsThuNo
                  : fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Thu phí'
                  ? columnsTP
                  : fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Chênh lệch'
                  ? columnsChenhLech
                  : fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Sửa chữa' ||
                    fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Bảo hành'
                  ? columnsSC
                  : fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Tháo - Lắp lại' &&
                    createOrders['dataBody']?.thaoLapTag === 3
                  ? columnsTLL
                  : fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Tháo - Lắp lại' &&
                    createOrders['dataBody']?.thaoLapTag == 2
                  ? columnsTL
                  : fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Tháo - Lắp lại' &&
                    createOrders['dataBody']?.thaoLapTag == 1
                  ? columnsTH
                  : columnsTD
              }
              pagination={false}
              dataSource={
                fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'ĐL lắp giùm' ||
                fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Trả hàng' ||
                fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Thu nợ' ||
                fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Chênh lệch' ||
                fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Thu phí' ||
                fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Sửa chữa' ||
                fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Bảo hành' ||
                fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Nâng cấp' ||
                fullTypeOrder[Number(createOrders['dataBody']?.orderTypeId) - 1] == 'Tháo - Lắp lại'
                  ? order
                  : createOrders['dataBody']?.items
              }
            ></Table>
          </div>
          <Divider className="" style={{ margin: 0, padding: '0px' }} />
        </div>
      );
    } else {
      return (
        <>
          <div className="p-3 bg-gray-50 rounded-t-lg border border-b-0 text-[13px]">
            {/* Hàng 1: Định danh đơn hàng (Dàn trải 4 cột) */}
            <div className="grid grid-cols-4 gap-4 mb-3 pb-2 border-b border-gray-200">
              <div>
                <div className="text-gray-500 text-[11px] uppercase tracking-wider">
                  {t('OrganizedSales.OrderManager.CorfirmOrder.TypeOrder')}
                </div>
                <div className="font-bold text-red-600 uppercase">
                  {createOrders['rowSelected']?.loaiDonHang === 'Tháo - Lắp lại'
                    ? `${createOrders['rowSelected']?.loaiDonHang} (${
                        tagTLL[Number(createOrders['rowSelected']?.thaoLapTag) - 1]
                      })`
                    : createOrders['rowSelected']?.loaiDonHang}
                </div>
              </div>
              <div>
                <div className="text-gray-500 text-[11px] uppercase tracking-wider">
                  {t('OrganizedSales.OrderManager.CorfirmOrder.BranchWork')}
                </div>
                <div className="font-bold text-red-600 uppercase">{createOrders['rowSelected']?.branchName || ''}</div>
              </div>
              <div>
                <div className="text-gray-500 text-[11px] uppercase tracking-wider">
                  {t('OrganizedSales.OrderManager.CorfirmOrder.TimeDeli')}
                </div>
                <div className="font-semibold">
                  {moment(new Date(createOrders['rowSelected']?.times?.thoiGianHenLap || '')).format(
                    'HH:mm DD/MM/YYYY'
                  )}
                </div>
              </div>
              <div className="text-right">
                <div className="text-gray-500 text-[11px] uppercase tracking-wider">
                  {t('OrganizedSales.OrderManager.CorfirmOrder.CoopType')}
                </div>
                <div className="font-bold text-red-600 uppercase">
                  {itemTypeCoop?.find(i => i.value === createOrders?.['rowSelected']?.customerInfo?.cooperationTypeId)
                    ?.label || ''}
                </div>
              </div>
            </div>

            {/* Hàng 2: Khách hàng & Tài chính */}
            <div className="grid grid-cols-4 gap-6 items-start">
              {/* Cột 1 & 2: Thông tin khách hàng */}
              <div className="col-span-2 grid grid-cols-2 gap-y-1 gap-x-4 border-r pr-4">
                <div className="col-span-1 truncate">
                  <span className="font-semibold">{t('OrganizedSales.OrderManager.CorfirmOrder.NameCus')}: </span>
                  {createOrders['rowSelected']?.CustomerName || ''}
                </div>
                <div className="col-span-1">
                  <span className="font-semibold">{t('OrganizedSales.OrderManager.CorfirmOrder.PhoneCus')}: </span>
                  <span className="text-red-500">{createOrders['rowSelected']?.CusNumberPhone || ''}</span>
                </div>
                <div className="col-span-1 truncate">
                  <span className="font-semibold">{t('OrganizedSales.OrderManager.CorfirmOrder.NameCusLH')}: </span>
                  {createOrders['dataBody']?.tenNguoiLienHe || '---'}
                </div>
                <div className="col-span-1">
                  {createOrders['dataBody']?.sdtLienHe && (
                    <>
                      <span className="font-semibold">
                        {t('OrganizedSales.OrderManager.CorfirmOrder.PhoneCusLH')}:{' '}
                      </span>
                      <span className="text-red-500">{createOrders['dataBody']?.sdtLienHe}</span>
                    </>
                  )}
                </div>
                <div className="col-span-2 mt-1">
                  <span className="font-semibold">{t('OrganizedSales.OrderManager.CorfirmOrder.Address')}: </span>
                  <span className="text-gray-600 italic">{createOrders['rowSelected']?.AddressShip || ''}</span>
                </div>
              </div>

              {/* Cột 3: Thanh toán & GD */}
              <div className="col-span-1 space-y-2">
                <div>
                  <span className="font-semibold">{t('OrganizedSales.OrderManager.CorfirmOrder.Method')}: </span>
                  <span className="text-blue-700 font-medium">
                    {createOrders['rowSelected']?.payment?.hinhThucThanhToan || ''}
                  </span>
                </div>
                {createOrders?.keyOrder !== 11 && (
                  <div>
                    <span className="font-semibold">{t('OrganizedSales.OrderManager.CorfirmOrder.VAT')}: </span>
                    <span className="font-medium">{createOrders['rowSelected']?.orderVat ? 'Có' : 'Không'}</span>
                  </div>
                )}
                {createOrders?.keyOrder === 11 && (
                  <div className="bg-orange-50 p-1.5 rounded border border-orange-100 text-[11px]">
                    <div>
                      <b>{t('OrganizedSales.OrderManager.CorfirmOrder.MaGD')}:</b>{' '}
                      {createOrders['rowSelected']?.ngayGiaoDich
                        ? dayjs(createOrders['rowSelected']?.ngayGiaoDich).format('DD-MM-YYYY')
                        : createOrders['rowSelected']?.maGiaoDich
                        ? dayjs(createOrders['rowSelected']?.maGiaoDich).format('DD-MM-YYYY')
                        : ''}
                    </div>
                    <div className="truncate">
                      <b>Nội dung:</b> {createOrders['rowSelected']?.noiDungChuyenKhoan}
                    </div>
                    <div className="text-red-600 font-bold mt-1">
                      DƯ NỢ: {Helpers.FormatMoney(createOrders['rowSelected']?.duNoKhachHang) || 0}
                    </div>
                  </div>
                )}
              </div>

              {/* Cột 4: Box Tiền */}
              <div className="col-span-1 bg-white p-2 rounded shadow-sm border border-gray-200 text-right">
                <div className="mb-2">
                  <span className="text-[10px] text-gray-400 block uppercase font-bold">
                    {t('OrganizedSales.OrderManager.CorfirmOrder.MoneyWill')}
                  </span>
                  <span className="text-lg font-bold text-blue-600">
                    {Helpers.FormatMoney(createOrders['rowSelected']?.payment?.tienThanhToan) || 0}
                  </span>
                </div>
                <div className="pt-1 border-t border-gray-100">
                  <span className="text-[10px] text-gray-400 block uppercase font-bold">
                    {t('OrganizedSales.OrderManager.CorfirmOrder.MoneyPayed')}
                  </span>
                  <span className="text-lg font-bold text-green-600">
                    {Helpers.FormatMoney(createOrders['rowSelected']?.payment?.tienThucThu) || 0}
                  </span>
                </div>
              </div>
            </div>

            {/* Thông tin VAT (Nằm trên 1 hàng duy nhất) */}
            {createOrders['rowSelected']?.orderVat?.mst && (
              <div className="mt-2 p-1.5 bg-red-50 border border-red-200 rounded text-[12px] flex items-center space-x-3">
                <div className="font-bold text-red-600 uppercase whitespace-nowrap border-r border-red-200 pr-3">
                  VAT
                </div>
                <div className="flex flex-1 items-center space-x-4 overflow-hidden">
                  <div className="whitespace-nowrap">
                    <span className="font-semibold text-gray-500">MST:</span>{' '}
                    {createOrders['rowSelected']?.orderVat?.mst}
                  </div>
                  <span className="text-red-200">|</span>
                  <div className="truncate max-w-[250px]">
                    <span className="font-semibold text-gray-500">Công ty:</span>{' '}
                    {createOrders['rowSelected']?.orderVat?.tenCongTy}
                  </div>
                  <span className="text-red-200">|</span>
                  <div className="whitespace-nowrap">
                    <span className="font-semibold text-gray-500">Email:</span>{' '}
                    {createOrders['rowSelected']?.orderVat?.email}
                  </div>
                  <span className="text-red-200">|</span>
                  <div className="truncate flex-1">
                    <span className="font-semibold text-gray-500">Địa chỉ:</span>{' '}
                    {createOrders['rowSelected']?.orderVat?.address}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div>
            <h2 className="ml-1">SẢN PHẨM: </h2>
            <Table
              scroll={{ y: heigth > 899 ? 400 : 200 }}
              columns={
                createOrders['rowSelected']?.loaiDonHang == 'Nâng cấp'
                  ? columnsNC
                  : createOrders['rowSelected']?.loaiDonHang == 'ĐL lắp giùm'
                  ? columnsDLLG
                  : createOrders['rowSelected']?.loaiDonHang == 'Trả hàng'
                  ? columnsTHang
                  : createOrders['rowSelected']?.loaiDonHang == 'Thu nợ'
                  ? columnsThuNo
                  : createOrders['rowSelected']?.loaiDonHang == 'Hàng gửi'
                  ? columnsHG
                  : createOrders['rowSelected']?.loaiDonHang == 'Thu phí'
                  ? columnsTP
                  : createOrders['rowSelected']?.loaiDonHang == 'Chênh lệch'
                  ? columnsChenhLech
                  : createOrders['rowSelected']?.loaiDonHang == 'Sửa chữa' ||
                    createOrders['rowSelected']?.loaiDonHang == 'Bảo hành'
                  ? columnsSC
                  : createOrders['rowSelected']?.loaiDonHang == 'Tháo - Lắp lại' &&
                    createOrders['rowSelected']?.thaoLapTag === 3
                  ? columnsTLL
                  : createOrders['rowSelected']?.loaiDonHang == 'Tháo - Lắp lại' &&
                    createOrders['rowSelected']?.thaoLapTag === 2
                  ? columnsTL
                  : createOrders['rowSelected']?.loaiDonHang == 'Tháo - Lắp lại' &&
                    createOrders['rowSelected']?.thaoLapTag === 1
                  ? columnsTH
                  : columns
              }
              pagination={false}
              dataSource={
                createOrders['rowSelected']?.loaiDonHang == 'Sửa chữa' ||
                createOrders['rowSelected']?.loaiDonHang == 'Chênh lệch' ||
                createOrders['rowSelected']?.loaiDonHang == 'ĐL lắp giùm' ||
                createOrders['rowSelected']?.loaiDonHang == 'Trả hàng' ||
                createOrders['rowSelected']?.loaiDonHang == 'Thu nợ' ||
                createOrders['rowSelected']?.loaiDonHang == 'Bảo hành' ||
                createOrders['rowSelected']?.loaiDonHang == 'Nâng cấp' ||
                createOrders['rowSelected']?.loaiDonHang == 'Tháo - Lắp lại' ||
                createOrders['rowSelected']?.loaiDonHang == 'Hàng gửi' ||
                createOrders['rowSelected']?.loaiDonHang == 'Thu phí'
                  ? order
                  : createOrders['valueDetails']
              }
            ></Table>
          </div>
          <Divider className="" style={{ margin: 0, padding: '0px' }} />
        </>
      );
    }
    // return <>{t('OrganizedSales.OrderManager.DraftOrderModal.NotDraftOrder')}</>;
  }, [chiNhanh, createOrders, fullTypeOrder, t, tagTLL, order]);

  const handleCreateOrder = async () => {
    try {
      const bodyReq = createOrders['dataBody'] || null;
      const typeApiReq = createOrders['typeOrderAPI'] || null;
      // console.log('bodyData,typeApi', createOrders, bodyReq, typeApiReq);
      if (
        bodyReq &&
        typeApiReq &&
        (uLogin?.ActionOrder?.createOrder ||
          (uLogin?.role === 'Accountant' && Number(createOrders['dataBody']?.orderTypeId) === 11) ||
          Number(createOrders['dataBody']?.orderTypeId) === 13 ||
          (uLogin?.role === 'Technician' && uLogin?.isGuiHang && Number(createOrders['dataBody']?.orderTypeId) === 12))
      ) {
        setConfirmLoading(true);
        //   // props.isModalCreate && props.setConfirmLoading(true);
        await OrderManagerApi.CreateNewOrder(bodyReq, typeApiReq).then(res => {
          // console.log('res', res);
          if (!res.data.error) {
            if (createOrders['dataBody']?.maDonHangCu) {
              if (createOrders['yeuCauChinhSua'] === 1) {
                // có gửi y/c chỉnh sửa
                message.success(t('OrganizedSales.OrderManager.CreateOrder.ChangeOrderSuccessRequest'));
                props.callBackConfirm && props.callBackConfirm();
              } else {
                message.success(t('OrganizedSales.OrderManager.CreateOrder.ChangeOrderSuccess'));
              }
            } else {
              message.success(t('OrganizedSales.OrderManager.CreateOrder.Success'));
            }
            dispatch(updateReqReGetOrder(true));
            setTimeout(() => {
              dispatch(updateOpenCreateModal(false));
              dispatch(updateOpenCreateOrderModal(false));
              props.resetAllForm && props.resetAllForm();
              props.callBackCloseModal && props.callBackCloseModal();
            }, 500);
          } else {
            if (createOrders['dataBody']?.maDonHangCu) {
              message.error(
                t('OrganizedSales.OrderManager.CreateOrder.ChangeOrderErrors') + ' ' + res.data.message,
                10
              );
            } else {
              message.error(t('OrganizedSales.OrderManager.CreateOrder.Error') + ' ' + res.data.message, 10);
            }
            // message.error(t('OrganizedSales.OrderManager.CreateOrder.Error') + ' ' + res.data.message, 10);
          }
          setConfirmLoading(false);
        });
      }
    } catch (error) {
      console.log(error);
      if (createOrders['dataBody']?.maDonHangCu) {
        message.error(t('OrganizedSales.OrderManager.CreateOrder.ChangeOrderErrors'));
      } else {
        message.error(t('OrganizedSales.OrderManager.CreateOrder.Error'));
      }
      // message.error(t('OrganizedSales.OrderManager.CreateOrder.Error'));
      setConfirmLoading(false);
    }
  };

  const handleOK = () => {
    if (
      uLogin?.ActionOrder?.createOrder ||
      uLogin?.ActionOrder?.createOrderChenhLech ||
      (uLogin?.role === 'Accountant' && Number(createOrders['dataBody']?.orderTypeId) === 11) ||
      (uLogin?.role === 'Technician' && uLogin?.isGuiHang && Number(createOrders['dataBody']?.orderTypeId) === 12)
    ) {
      // gọi api tạo đơn hàng..
      handleCreateOrder();
    } else {
      // thông báo k có quyền tạo
      message.info(t('OrganizedSales.OrderManager.CreateOrder.NotAccept'));
    }
  };

  const handleActionStaff = async (type?: TTypeStatusAPI, data?: any, typeMsg?: TTypeStatusMsg) => {
    console.log('handleActionStaff', type, data);
    try {
      dispatch(updatePageLoadingApi(true));
      await OrderManagerApi.ActionStatusOrder(type, data).then(res => {
        console.log('res', res, !res.data.error);
        if (!res.data.error) {
          message.success(t('OrganizedSales.OrderManager.CorfirmOrder.SuccessOrder'));
          // dispatch(updateReqReGetOrder(true)); // chỉ update đơn đang thao tác !!
          setTimeout(() => {
            dispatch(
              getDetailOfOrder({ maDonHang: data.maDonHang, typeOrder: createOrders['rowSelected']?.orderType?.id })
            ); // gọi lên lấy data mới luôn !!
          }, 250);
          props.resetAllForm && props.resetAllForm();
          dispatch(updateOpenCreateModal(false));
          // dispatch(updateOpenCreateOrderModal(false));
          // updateOpenCreateModal
        } else {
          // SubMsg
          message.error(t('OrganizedSales.OrderManager.CorfirmOrder.FailureOrder') + '. ' + `${res.data.message}`);
        }
        setTimeout(() => {
          dispatch(updatePageLoadingApi(false));
        }, 250);
      });
    } catch (error) {
      console.log(error);
      dispatch(updatePageLoadingApi(false));
      message.error(t('OrganizedSales.OrderManager.CorfirmOrder.FailureOrder'));
    }
  };

  const handleOK2 = () => {
    handleActionStaff(createOrders['typeStatus'], createOrders['body'], 'Completed');
  };

  return (
    <div>
      <ModalComponent
        modalTitle={
          props?.typeOrder === 'doidonhang'
            ? t('OrganizedSales.OrderManager.CorfirmOrder.Title2')
            : t('OrganizedSales.OrderManager.CorfirmOrder.Title')
        }
        modalType="confirm"
        modalSize="large"
        visible={openCodeCreateModal}
        onOk={props?.typeOrder === 'xacnhandonhang' ? handleOK2 : handleOK}
        // hiddenFooter={true}
        // confirmLoading={confirmLoading}
        onCancel={handleCancel}
        // justifyMiddle={true}
      >
        <div className="overflow-y-auto max-h-[80vh]">{renderListOrder}</div>
      </ModalComponent>
    </div>
  );
}
